import React from 'react';

import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { WysiwygField } from '../../../components';

const ParagraphGetStarted = ({ entity }) => {
  const items = entity.getIn(['field_subparagraphs']);
  const title = entity.getIn(['field_title', 0, 'value']);
  const subtitle = entity.getIn(['field_subtitle', 0, 'value']);
  const body = entity.getIn(['field_body', 0, 'processed']);
  const flipped = entity.getIn(['field_flipped', 0, 'value']);

  return (
    <Container>
      <div className="Paragraph ParagraphGetStarted">
        <div className="row">
          <div className="col-12">
            <div className={`row ParagraphGetStarted__Inner ${flipped && 'flipped'}`}>
              <div className="col-12 col-lg-6">
                {subtitle && (
                  <div className="ParagraphGetStarted__Caption">
                    {subtitle}
                  </div>
                )}
                <div className="ParagraphGetStarted__Title">
                  <h3 className="asH4">{title}</h3>
                </div>
                {body && (
                  <WysiwygField
                    property="schema:text"
                    className="ParagraphGetStarted__Body subheading2"
                    html={body}
                  />
                )}
              </div>
              <div className="col-12 col-lg-6">
                {items && items.map((item, index) => {
                  const subparagraphEntity = item.get('entity');
                  const entityId = item.get('target_id');
                  return (
                    <div key={entityId} className="ParagraphGetStarted__Subparagraph">
                      <Paragraph id={entityId} viewMode="getStarted" entity={subparagraphEntity} />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

        </div>
      </div>
    </Container>
  );
};

export default ParagraphGetStarted;
